// extracted by mini-css-extract-plugin
module.exports = {"SanityImage":"SanityImage_SanityImage__8h2FE","hasDataUri":"SanityImage_hasDataUri__W7Nz0","loaded":"SanityImage_loaded__40x8l"};